import { render } from "./Upload_Documents.vue?vue&type=template&id=306a9139&scoped=true"
import script from "./Upload_Documents.vue?vue&type=script&lang=js"
export * from "./Upload_Documents.vue?vue&type=script&lang=js"

import "./Upload_Documents.vue?vue&type=style&index=0&id=306a9139&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306a9139"]])

export default __exports__